export const reservas = {
    // Filtro con el que llega el listado desde las cajas del dashboard
    filtroLlegadas: {
        today: `Arrivées aujourd'hui`,
        tomorrow: `Arrivées demain`,
        this_week: `Arrivées cette semaine`,
        month: `Arrivées ce mois-ci`,
        upcoming: `Arrivées à venir`,
    },
    filtroSalidas: {
        today: `Départs aujourd'hui`,
    },
    quitarFiltro: `Retirer le filtre`,
    // Estancia vendida por horas registrada como reserva
    rapida: `Rapide`,
    p1:`Liste des réservations`,
    p2:`Liste des réservations enregistrées sur la plateforme`,
    p3:`Plus d'actions`,
    p4:`Planifier le check-in`,
    p5:`Aujourd'hui`,
    p6:`Code de réservation`,
    p7:`Prénom`,
    p8:`E-mail`,
    p9:`Date de check-in`,
    p10:`Acompte`,
    p11:`Nombre de clients`,
    p12:`Statut : `,
    p13:`Montant : `,
    p14:`Statut : `,
    p15:`En attente`,
    p16:`Terminé`,

    p17:`Plus d'actions`,
    p18:`Importer des réservations`,
    p19:`Téléchargez un modèle Excel, remplissez les données de vos réservations et importez-le pour créer plusieurs réservations à la fois.`,

    p20:`Check-in planifié`,
    p21:`Informations détaillées du check-in planifié`,
    p22:`Statut : `,
    p23:`Payé`,
    p24:`Paiement en attente`,
    p25:`Modifier le statut de paiement`,
    p26:`Responsable du check-in`,
    p27:`Envoyer le check-in en ligne`,
    p28:`Envoi du lien de check-in...`,
    p29:`Envoyer automatiquement le lien de check-in en ligne aux clients`,
    p30:`Une semaine avant le check-in`,
    p31:`72 heures avant le check-in`,
    p32:`48 heures avant le check-in`,
    p33:`24 heures avant le check-in`,
    p34:`Enregistrer les modifications`,
    p35:`Date de check-in`,
    p36:`Date de check-out`,
    p37:`Clients enregistrés`,
    p38:`Liste des check-ins effectués`,
    p39:`Prénom`,
    p41:`Nom`,
    p42:`Date de check-in`,
    p43:`E-mail`,
    p44:`Processus`,
    p45:`Scanné`,
    p46:`Manuel`,
    p47:`Manuel opérateur`,
    p48:`Téléphone`,
    p49:`Aucun check-in enregistré`,

    p50:`Statut de paiement de la réservation`,
    p51:`Modifier manuellement le statut de paiement de la réservation.`,
    p52:`Sélectionnez l'une des options`,
    p53:`En attente`,
    p54:`Payé`,
    p55:`Annuler`,
    p56:`Modifier le statut`,
    p57:`Non spécifié`,
    p58:`Terminé`,
    p59:`Aucune réservation enregistrée pour le moment`,
    p60:`Check-ins planifiés`,
    p61:`Modifications enregistrées avec succès`,
    p62:`Voulez-vous envoyer le lien de check-in ?`,
    p63:`Envoyer le lien`,
    p64:`Annuler`,
    p65:`Demande de check-in envoyée avec succès`,

    p66:`Propriété ou utilisateur introuvable.`,
    p67:`Erreur lors de la génération du jeton`,
    p68:`Erreur de connexion au canal. Veuillez réessayer.`,
    p69:`Disponibilité et tarifs`,
    p70:`Gérez les jours disponibles et les tarifs de votre hébergement`,
    p71:`Pour activer cette fonctionnalité, vous devez disposer d'un forfait actif. Vous pourrez voir instantanément la disponibilité de votre hébergement, ajuster les tarifs selon la saison ou les événements spéciaux, et tout gérer depuis un seul endroit.`,
    p72:`En annulant cette réservation, les dates redeviendront disponibles sur tous les portails connectés`,
    p73:`Annuler la réservation`,
    p74:`Réservation annulée avec succès`,
    p75:`Réservation de `,
    p76:` annulée.`,
    p77:`Vous ne pouvez pas réserver sur des dates bloquées.`,
    p78:`Vérifiez les dates sélectionnées`,
    p79:`Vous devez sélectionner au moins une nuit pour la réservation.`,
    p80:`Les dates sélectionnées ne sont pas disponibles.`,
    p81:`Rappels`,
    p82:`Gérez les rappels pour vos clients`,
    p83:`Créer un nouveau rappel`,
    p84:`Jour`,
    p85:`Heure`,
    p86:`Description`,
    p87:`Supprimer le rappel`,
    p88:`Aucun rappel trouvé`,
    p89:`Êtes-vous sûr de vouloir supprimer le rappel ?`,
    p90:`Vous perdrez les données enregistrées`,
    p91:`Supprimer le rappel`,
    p92:`Rappel supprimé avec succès`,
    p93:`Première étape :`,
    p94:`Sélectionnez le pays où vous avez des réservations et téléchargez le modèle pour remplir les données.`,
    p95:`Télécharger le modèle`,
    p96:`Deuxième étape :`,
    p97:`Importez le(s) même(s) modèle(s) que vous avez téléchargé(s) avec les données ajoutées.`,
    p98:`Importer`,
    p99:`Vous devez importer le modèle pour poursuivre l'importation`,
    p100:`Processus terminé avec succès`,
    p101:`Erreur lors du processus d'importation`,
    p102:`Disponible`,
    p103:`Occupé`,
    p104:`Nettoyage`,
    p105:`Maintenance`,
    p106:`Erreur lors de l'annulation de la réservation`,
    p107:`Erreur lors de la mise à jour de l'affichage après l'annulation`,
    p108:`Impossible d'ouvrir le changement de chambre. Réservation invalide.`,
    p109:`Impossible d'identifier la chambre actuelle.`,
    p110:`Disponibilité mise à jour avec succès`,
    p111:`Calendrier de l'hôtel`,
    p112:`Gérez vos réservations visuellement et gardez un contrôle total sur la disponibilité de votre hôtel.`,
    p113:`Modifier la disponibilité`,
    p114:`Créer une réservation`,
    p115:`Les réservations en pause ne seront pas envoyées automatiquement`,
    p116:`L'envoi automatique sera activé pour cette réservation`,
    p117:`Mettre en pause`,
    p118:`Activer`,
    p119:`la réservation`,
    p120:`Oui`,
    p121:`Réservation mise en pause avec succès`,
    p122:`Processus terminé avec succès`,
    p123:`Réservation activée avec succès`,
    p124:`Réservations synchronisées et créées manuellement`,
    p125:`Date invalide`,
    p126:`Date invalide`,
    p127:`L'invitation au check-in sera envoyée le `,
    p128:`Réservation en pause`,
    p129:`Réservation annulée`,
    p130:`Terminé`,
    p131:`Toutes vos réservations avec les détails de chaque check-in et client apparaîtront ici. Lorsque vous recevrez votre première réservation, vous la verrez ici même.`,
    p132:`Propriété sélectionnée`,
    p133:`Multiple`,
    p134:`Mensuel`,
    p135:`Fermé`,
    p136:`Dates mises à jour avec succès`,
    p137:`Erreur lors du chargement des données de la propriété`,
    p138:`Les dates sélectionnées ne sont pas disponibles. Des réservations ou des dates fermées provoquent un conflit.`,
    p139:`Réservation créée avec succès`,
    p140:`Plage`,
    p141:`fermée avec succès`,
    p142:`Erreur lors du blocage des dates`,
    p143:`Erreur lors de la suppression des dates fermées`,
    p144:`Prix mis à jour avec succès`,
    p145:`Erreur lors de la mise à jour des prix`,
    p146:`Êtes-vous sûr de vouloir annuler cette réservation ?`,
    p147:`Confirmer l'annulation`,
    p148:`Oui, annuler`,
    p149:`Non`,
    p150:`Réservation annulée avec succès`,
    p151:`Erreur lors du chargement des propriétés`,
    p152:`Nouvelle réservation ajoutée au calendrier`,
    p153:`Cette réservation provient d'un canal externe (OTA). Il n'est pas recommandé de l'annuler directement depuis ce système. Veuillez contacter le client et lui demander d'annuler la réservation via le canal d'origine.`,
    p154:`Réservation OTA - Annulation non autorisée`,
    p155:`Compris`,
    p156:`Erreur lors du traitement de la demande`,
    p157:`Lien copié avec succès`,
    p158:`Copié !`,
    p159:`Une erreur s'est produite lors de la copie du lien`,
    p160:`Erreur`,
    p161:`Envoyer le check-in au responsable de la réservation`,
    p162:`Envoyer le check-in`,
    p163:`Envoyer`,
    p164:`Erreur lors du chargement de la réservation`,
    p165:`Informations du check-in`,
    p166:`Envoyer la demande de check-in`,
    p167:`Toutes les réservations`,
    p168:`Réservations à venir`,
    p169:`Réservations annulées`,
    p170:`Clients`,
    p171:`Date de check-in`,
    p172:`Check-in`,
    p173:`Réservé`,
    p174:`Surréservation`,
    p175:`Annulée`,
    p176:``,
    p177:``,
    p178:``,
    p179:``,
    p180:``,
    p181:``,
    p182:``,
    p183:``,
}
